/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponid200,
  DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponid400,
  DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponid401,
  DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponid500,
  DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidMutationResponse,
  DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidPathParams,
  DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidQueryParams,
} from "../../types/individualPaymentEditorsController/DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponid.ts";

export const deleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidPathParamsSchema =
  z.object({
    financialPersonId: z.coerce.number().int(),
    couponId: z.coerce.number().int(),
  }) as unknown as ToZod<DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidPathParams>;

export const deleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidQueryParamsSchema =
  z
    .object({
      justification: z.optional(z.string()),
    })
    .optional() as unknown as ToZod<DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const deleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponid200Schema =
  z.any() as unknown as ToZod<DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponid200>;

/**
 * @description Regra de negócio violada
 */
export const deleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponid400Schema =
  z.any() as unknown as ToZod<DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponid400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponid401Schema =
  z.any() as unknown as ToZod<DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponid401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponid500Schema =
  z.any() as unknown as ToZod<DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponid500>;

export const deleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidMutationResponseSchema =
  z.lazy(
    () =>
      deleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponid200Schema,
  ) as unknown as ToZod<DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidMutationResponse>;
